import { AxiosGetMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

/**
 * Looks up an operator by their 12-digit Aadhaar number.
 * Returns the operator data object on success, or null if not found / error.
 */
const getOperatorByAadhaar = async (aadhaar) => {
  const res = await AxiosGetMethod(
    `org/get-operator-by-aadhaar?aadhaar=${aadhaar}`,
  );

  if (res?.status === 401) {
    HandleLogout();
    return null;
  }

  if (res?.status === 200 && res?.data?.data) {
    return res.data.data;
  }

  return null;
};

export default getOperatorByAadhaar;
